import { IconProps } from ".";
import Icon from "./assets/doc_upload_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24DocUpload(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
